import General from '../helpers/General';
import Stats from '../helpers/Stats';
import { metaobjectsGetCollabs } from '../helpers/Metaobjects';
import { getHeaderSectionHeight } from '../helpers/HeaderSection';
import { forEach } from 'lodash';

let controller;
let fetch_active = false;

const textToCamelCase = (str) => {
  return str
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase()) // Usuwanie niealfanumerycznych znaków i zmiana kolejnej litery na dużą
    .replace(/^[a-z]/, (chr) => chr.toUpperCase()); // Zmiana pierwszej litery na wielką
};

const filterIDCollab = 'filter.p.m.GLDProductsDetails.collab';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.controller = new AbortController();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.limit = document.querySelector(
      '.template-collection__products'
    ).dataset.limit;

    this.debouncedOnSubmit = General.debounce((event) => {
      if (controller) {
        controller.abort();
      }
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // FacetFiltersForm.setCollabs();
    // if (facetForm)
    // facetForm.addEventListener('onChange', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initFixedHeaderFilters();
  }

  initFixedHeaderFilters() {
    const headerFiltersElement = document.querySelector(
      '.js-collection-header-filters'
    );
    const headerFiltersFixedClass = 'is-fixed';
    const resultsContainer = document.querySelector(
      '.template-collection__products'
    );

    let updating = false;
    let headerFiltersThreshold;
    let headerFiltersHeight = 0;
    let containerBottom = 0;

    const updateHeaderFiltersThreshold = () => {
      const header = document.querySelector('.js-collection-header');
      if (!header || !headerFiltersElement || !resultsContainer) return;

      requestAnimationFrame(() => {
        headerFiltersThreshold =
          header.getBoundingClientRect().top + window.scrollY;
        headerFiltersHeight = headerFiltersElement.offsetHeight;
        containerBottom =
          resultsContainer.getBoundingClientRect().bottom + window.scrollY;
      });
    };

    const handleScroll = () => {
      if (!headerFiltersElement || !resultsContainer) return;

      const scrollTop =
        (document.documentElement.scrollTop || document.body.scrollTop) + 100;
      const headerBottomPosition = scrollTop + headerFiltersHeight;

      const isWithinContainer =
        scrollTop >= headerFiltersThreshold &&
        headerBottomPosition < containerBottom;

      if (isWithinContainer) {
        headerFiltersElement.classList.add(headerFiltersFixedClass);
      } else {
        headerFiltersElement.classList.remove(headerFiltersFixedClass);
      }

      updating = false;
    };

    const onScroll = () => {
      if (!updating) {
        updating = true;
        window.requestAnimationFrame(handleScroll);
      }
    };

    let resizeTimeout;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateHeaderFiltersThreshold();
        handleScroll();
      }, 200);
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', handleResize);
    window.addEventListener('DOMContentLoaded', updateHeaderFiltersThreshold);
    window.addEventListener('load', updateHeaderFiltersThreshold);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setURL(searchParams, event = null) {
    const wrapper = event?.target
      ? event.target.closest('.colection-template__section-wrapper')
      : document.querySelector('.colection-template__section-wrapper');
    if (wrapper?.dataset?.sectionId) {
      searchParams += `${searchParams != '' ? '&' : ''}section_id=${
        wrapper.dataset.sectionId
      }`;
    }
    return `${window.location.pathname}?${searchParams}`;
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    document
      .querySelector('.template-collection__content')
      .classList.add('preloader');
    const url = FacetFiltersForm.setURL(searchParams, event);
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : await FacetFiltersForm.renderSectionFromFetch(url, event);
    // });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (event?.target) {
      const type =
        event.target.name ||
        event.target?.dataset?.name ||
        event.target?.parentNode?.dataset?.name;
      const value =
        event.target?.value ||
        event.target.dataset?.value ||
        event.target?.parentNode?.dataset?.value;
      const inputType =
        event.target.type ||
        event.target?.dataset?.type ||
        event.target?.parentNode?.dataset?.type;
      const filterLabel = event.target?.dataset?.filterLabel;
      const isChecked = event.target.checked;

      const event_category = 'filters--new';

      if (type && value) {
        if (Stats?.sendEventDataLayerViaShopify) {
          const eventFilterName = filterLabel || type;
          const eventValue = textToCamelCase(value);

          if (type == 'filter.v.m.GLDProductsDetails.color') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${eventValue}`,
            });
          } else if (type == 'filter.v.availability') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_boolean_${isChecked}`,
            });
          } else if (inputType == 'checkbox') {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${inputType}_${isChecked}_${eventValue}`,
            });
          } else {
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `${eventFilterName}_${inputType}_${eventValue}`,
            });
          }
        }

        if (window.gld_dy && window.gld_dy.enabled) {
          window.gld_dy.event({
            name: 'Filter Items',
            properties: {
              dyType: 'filter-items-v1',
              filterType: type,
              filterStringValue: value,
            },
          });
        }
      }
    }

    window.callbacks_filters_after_render_products =
      window.callbacks_filters_after_render_products || [];
    if (window?.callbacks_filters_after_render_products.length) {
      window.callbacks_filters_after_render_products.forEach((callback) =>
        callback()
      );
    }
  }

  static abortController = new AbortController();
  static fetchActive = false;

  static async renderSectionFromFetch(url, event) {
    try {
      controller = new AbortController();
      const signal = controller.signal;
      //         FacetFiltersForm.fetchActive = true;
      // fetch_active = true;
      const query = await fetch(url, { signal });
      // fetch_active = false

      const response = await query.text();
      const html = response;
      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        { html, url },
      ];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.runBeforeRenderProductsCallbacks();
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.renderProductCountFilters(html);
      FacetFiltersForm.renderProductSortbyNavFilter(html);
    } catch (err) {
      console.error(`Get filters error: ${err.message}`);
      fetch_active = false;
    }
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.runBeforeRenderProductsCallbacks();
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderProductCountFilters(html);
    FacetFiltersForm.renderProductSortbyNavFilter(html);
    // window.callbacks_filters_after_render_products = window.callbacks_filters_after_render_products || []
    // if (window?.callbacks_filters_after_render_products.length) {
    //     window.callbacks_filters_after_render_products.forEach(callback => callback())
    // }
  }

  static runBeforeRenderProductsCallbacks() {
    window.callbacks_filters_before_render_products =
      window.callbacks_filters_before_render_products || [];
    if (window?.callbacks_filters_before_render_products.length) {
      window.callbacks_filters_before_render_products.forEach((callback) =>
        callback()
      );
    }
  }

  static renderProductGridContainer(html) {
    // console.log('html', html);
    html = new DOMParser().parseFromString(html, 'text/html');
    const products = html.querySelector('.template-collection__products');
    const filters = html.querySelector('.template-collection__filters');
    const filtersBest = html.querySelector(
      '.gld-filters-top[data-filter-type="best"] .gld-filters-top__list'
    );
    if (products) {
      document.querySelector('.template-collection__products').innerHTML =
        products.innerHTML.replaceAll('pagination--preloader', '');
    }
    if (filtersBest) {
      document.querySelector(
        '.gld-filters-top[data-filter-type="best"] .gld-filters-top__list'
      ).innerHTML = filtersBest.innerHTML;
    }
    if (filters) {
      document.querySelector('.template-collection__filters').innerHTML =
        filters.innerHTML;
    }
    if (window.LazyLoaderRun) {
      window.LazyLoaderRun();
    }
    if (window.dy_productCardPerformance) {
      window.dy_productCardPerformance();
    }
    FacetFiltersForm.srollToTopSection();
    document
      .querySelector('.template-collection__content')
      .classList.remove('preloader');
  }

  static renderProductCount(html) {
    const productList = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.template-collection__products__list');
    const count = productList ? productList.dataset.productsCount : 0;
    const countCountainer = document.querySelector(
      '.template-collection__header__text__count'
    );
    if (countCountainer) {
      document.querySelector(
        '.template-collection__header__text__count'
      ).innerHTML = `(${count})`;
    }
  }

  static renderProductSortbyNavFilter(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const sortbyCheckedInput = parsedHTML.querySelector(
      'input[name="sort_by"][checked]'
    );
    const sortbyCheckedLabel = parsedHTML.querySelector(
      'input[name="sort_by"][checked] + label'
    );

    const customSelectSort = document.querySelector(
      '.custom-select[data-config="sort"]'
    );

    if (customSelectSort) {
      const customSelectSortValue = customSelectSort.querySelector(
        '.custom-select__selected__value'
      );
      const customSelectSortOptions = customSelectSort.querySelectorAll(
        '.custom-select__options__item'
      );

      if (customSelectSortValue && customSelectSortOptions) {
        customSelectSortOptions.forEach(function (option) {
          option.classList.remove('custom-select__options__item--selected');
          option.removeAttribute('data-selected');
        });

        customSelectSortValue.innerText = sortbyCheckedLabel
          ? sortbyCheckedLabel.innerText
          : customSelectSortValue.innerText;

        const newSelectedOption = document.querySelector(
          `.custom-select__options__item[data-value="${sortbyCheckedInput.value}"]`
        );

        if (newSelectedOption) {
          newSelectedOption.classList.add(
            'custom-select__options__item--selected'
          );
          newSelectedOption.setAttribute('data-selected', 'selected');
        }
      }
    }
  }

  static renderProductCountFilters(html) {
    const counter_filters = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(
        '.template-collection__header__filters__item__label__icon__counter'
      );
    const count = counter_filters ? counter_filters.innerText : 0;
    const countCountainer = document.querySelector(
      '.template-collection__header__filters__item__label__icon__counter'
    );
    if (countCountainer) {
      countCountainer.innerText = count;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static async setCollabs() {
    const activeFiltersElement = document.querySelector(
      '.gld-filter--active-filters'
    );
    const filterCollabsElement = document.querySelector('.gld-filters-collabs');
    const filterCollabItemsElements = [
      ...document.querySelectorAll(
        'input[name="filter.p.m.GLDProductsDetails.collab_item"]'
      ),
    ];
    console.log('filterCollabItemsElements', filterCollabItemsElements);
    if (
      activeFiltersElement?.dataset?.collabsGet !== '0' ||
      filterCollabsElement ||
      filterCollabItemsElements.length
    ) {
      const collabsData = await metaobjectsGetCollabs();
      const collabFilters = [
        ...document.querySelectorAll(`input[name="${filterIDCollab}"]`),
      ];
      const filterCollabs = document.querySelector('.gld-filters-collabs');

      const replaceTagName = (oldElement, newTagName) => {
        const newElement = document.createElement(newTagName);
        // Copy attributes
        for (const attr of oldElement.attributes) {
          newElement.setAttribute(attr.name, attr.value);
        }

        // Move children
        while (oldElement.firstChild) {
          newElement.appendChild(oldElement.firstChild);
        }

        // Replace in DOM
        oldElement.parentNode.replaceChild(newElement, oldElement);

        return newElement;
      };

      const setURL = ({ element, handle }) => {
        if (element) {
          element.style.pointerEvents = 'none';
          element.parentNode.querySelector('label').style.pointerEvents =
            'none';
          replaceTagName(element.parentNode, 'a');
          if (handle) {
            element.parentNode.setAttribute('href', `/collections/${handle}`);
          }
        }

        // collabItemFilter.style.pointerEvents = "none";
      };

      if (collabFilters?.length) {
        collabFilters.forEach((collabFilter) => {
          const value = collabFilter.value;
          if (collabsData?.groups?.[value]) {
            const collabItemsFilters = [
              ...collabFilter.parentNode.querySelectorAll(
                `input[name="filter.p.m.GLDProductsDetails.collab_item"]`
              ),
            ];
            collabItemsFilters.forEach((collabItemFilter) => {
              if (
                collabsData?.groups?.[value].includes(collabItemFilter.value)
              ) {
                const metaobjectData = collabsData?.list.find(
                  (metaobjectItem) =>
                    metaobjectItem.id === collabItemFilter.value
                );
                collabItemFilter.parentNode.classList.remove(
                  'gld-filter__options__item--preloader'
                );
                if (metaobjectData?.fields?.collection) {
                  setURL({
                    element: collabItemFilter,
                    handle: metaobjectData?.fields?.collection,
                  });
                  // replaceTagName(collabItemFilter.parentNode, "a");
                  // collabItemFilter.parentNode.setAttribute(
                  //   "href",
                  //   `/collections/${metaobjectData?.fields?.collection}`
                  // );

                  // collabItemFilter.style.pointerEvents = "none";
                  // collabItemFilter.parentNode.querySelector(
                  //   "label"
                  // ).style.pointerEvents = "none";
                }
              } else {
                if (collabItemFilter.parentNode) {
                  collabItemFilter.parentNode?.remove();
                }
              }
            });
          }
        });
      } else if (filterCollabItemsElements.length) {
        filterCollabItemsElements.forEach((collabItemFilter) => {
          const metaobjectData = collabsData?.list.find(
            (metaobjectItem) => metaobjectItem.id === collabItemFilter.value
          );
          collabItemFilter.parentNode.classList.remove(
            'gld-filter__options__item--preloader'
          );
          console.log(
            'metaobjectData?.fields?.collection',
            metaobjectData?.fields?.collection
          );
          if (metaobjectData?.fields?.collection) {
            const props = {
              element: collabItemFilter,
              handle: metaobjectData?.fields?.collection,
            };
            setURL(props);
            // replaceTagName(collabItemFilter.parentNode, "a");
            // collabItemFilter.parentNode.setAttribute(
            //   "href",
            //   `/collections/${metaobjectData?.fields?.collection}`
            // );

            // collabItemFilter.style.pointerEvents = "none";
            // collabItemFilter.parentNode.querySelector(
            //   "label"
            // ).style.pointerEvents = "none";
          }
        });
      }

      if (filterCollabs) {
        const addTextBeforeExtension = (url, textToAdd) => {
          const lastDotIndex = url.lastIndexOf('.');
          if (lastDotIndex === -1) return url; // No extension found

          const base = url.substring(0, lastDotIndex);
          const extension = url.substring(lastDotIndex);

          return `${base}${textToAdd}${extension}`;
        };

        const list = filterCollabs.querySelector('.gld-filters-collabs__list');
        if (list) {
          const items = [
            ...list.querySelectorAll('.gld-filters-collabs__list__item'),
          ];

          items.forEach((item) => {
            const metaobjectData = collabsData?.list.find(
              (metaobjectItem) =>
                metaobjectItem.id === item.dataset.metaobjectId
            );
            if (metaobjectData) {
              if (metaobjectData?.fields?.team_logo) {
                const imgContainer = item.querySelector(
                  '.gld-filters-collabs__list__item__image'
                );
                if (imgContainer && !imgContainer.querySelector('img')) {
                  const image = document.createElement('img');
                  image.setAttribute(
                    'src',
                    addTextBeforeExtension(
                      metaobjectData?.fields?.team_logo,
                      '_240x240_crop_center'
                    )
                  );
                  image.setAttribute('alt', metaobjectData?.fields?.team);
                  imgContainer.appendChild(image);
                }
              }
              if (metaobjectData?.fields?.collection != null) {
                item.setAttribute(
                  'href',
                  `/collections/${metaobjectData?.fields?.collection}`
                );
              } else {
                item.style.display = 'none';
              }
            }
          });
        }
      }
    }
  }

  static renderCollabsList({ data }) {
    const { items } = data;

    const list = document.createElement('div');
    list.classList.add('gld-filter__options');
    list.classList.add('gld-filter__options--level-2');

    items
      .map((item) => {
        const itemHTML = document.createElement('div');
        itemHTML.classList.add('gld-filter__options__item');
        itemHTML.classList.add('flex-box');
        itemHTML.classList.add('flex-box--ai--center');
        itemHTML.classList.add('flex-box--flow--wrap');

        const inputHTML = document.createElement('input');
        inputHTML.classList.add('gld-filter__options__item__checkbox');
        inputHTML.classList.add('custom-checkbox');

        inputHTML.setAttribute('type', 'checkbox');
        inputHTML.setAttribute(
          'name',
          'filter.p.m.GLDProductsDetails.collabItem'
        );
        inputHTML.setAttribute('value', item.id);
        inputHTML.setAttribute('id', item.id);
        inputHTML.setAttribute('data-filter-label', item.fields.team);
        inputHTML.setAttribute('data-filter-label', item.fields.team);

        const labelHTML = document.createElement('label');
        labelHTML.classList.add('gld-filter__options__item__label');
        labelHTML.classList.add('flex-box');
        labelHTML.classList.add('flex-box--ai--center');
        labelHTML.setAttribute('value', item.id);
        labelHTML.setAttribute('for', item.id);
        labelHTML.setAttribute('role', 'button');

        const spanlHTML = document.createElement('span');
        spanlHTML.classList.add('gld-filter__options__item__label__text');
        spanlHTML.innerText = item.fields.team;

        const span2lHTML = document.createElement('span');
        span2lHTML.classList.add('gld-filter__options__item__label__counter');

        labelHTML.appendChild(spanlHTML);
        labelHTML.appendChild(span2lHTML);

        itemHTML.appendChild(inputHTML);
        itemHTML.appendChild(labelHTML);

        return itemHTML;
      })
      .forEach((item) => {
        list.appendChild(item);
      });

    return list;
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // this.controller.abort();
    FacetFiltersForm.renderPage(searchParams, event, true);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form'
    );

    const parent = event.target.closest('.gld-filter__options__item');
    if (parent && [...parent.querySelectorAll('.gld-filter__options')].length) {
      const inputs = [
        ...parent
          .querySelector('.gld-filter__options')
          .querySelectorAll('input'),
      ];
      // console.log(inputs);
      inputs.map((input) => (input.checked = false));
    }

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form')
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      // const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        // if (!isMobile) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => {
            if (el) {
              el?.remove();
            }
          });
          forms.push(this.createSearchParams(form));
        }
        // } else if (form.id === 'FacetFiltersFormMobile') {
        //     forms.push(this.createSearchParams(form));
        // }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let item = event.target.closest('facet-remove');
    if (!item && event.target.nodeName === 'facet-remove') {
      item = event.target;
    }
    const url =
      item.dataset.href.indexOf('?') == -1
        ? ''
        : item.dataset.href.slice(item.dataset.href.indexOf('?') + 1);
    if (controller) {
      controller.abort();
    }

    if (Stats?.sendEventDataLayerViaShopify) {
      const event_category = 'filters--new';
      const eventLabelValue = textToCamelCase(item.innerText || '');

      if (url) {
        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: `filter_remove_${eventLabelValue}`,
        });
      } else {
        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: 'clear_filters',
        });
      }
    }

    FacetFiltersForm.renderPage(url, event, true);
  }

  onBestFilterClick(event) {
    event.preventDefault();

    // FacetFiltersForm.toggleActiveFacets();
    let item = event.target.closest('facet-best');
    if (!item && event.target.nodeName === 'facet-best') {
      item = event.target;
    }
    item.classList.add('pill--loading');
    const url =
      item.dataset.href.indexOf('?') == -1
        ? ''
        : item.dataset.href.slice(item.dataset.href.indexOf('?') + 1);
    if (controller) {
      controller.abort();
    }
    item.classList.toggle('pill--dark');
    FacetFiltersForm.renderPage(url, event, true);
  }

  static srollToTopSection() {
    const offset = getHeaderSectionHeight() + 20;
    const breakpoint =
      document.querySelector('#collectionTopHeader') ||
      document.querySelector('.template-collection__products');
    // console.log('breakpoint', breakpoint.getBoundingClientRect().top, offset);
    if (breakpoint) {
      const scrollBreakpoint =
        breakpoint.getBoundingClientRect().top - offset + window.scrollY;
      if (scrollBreakpoint) {
        window.scrollTo({ top: scrollBreakpoint, behavior: 'smooth' });
      }
    }
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
// customElements.define('gld-filters-top', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    // this.querySelectorAll('input')
    //     .forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
    const onRangeChange = this.onRangeChange.bind(this);
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('input', General.debounce(onRangeChange, 500))
    );
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.target);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = input.value != '' ? Number(input.value) : false;
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value !== false && value < min) input.value = min;
    if (value !== false && value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetBest extends HTMLElement {
  constructor() {
    super();
    const facetLink = this;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onBestFilterClick(event);
  }
}

customElements.define('facet-best', FacetBest);
